var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    { staticClass: "telLink", attrs: { href: "tel:" + _vm.value } },
    [
      _vm.$slots.default
        ? [_vm._t("default")]
        : [_vm._v("\n    " + _vm._s(_vm.value) + "\n  ")],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }